// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8a47d4ea","821":"b5d405be"}[chunkId] + ".chunk.js";
};